// extracted by mini-css-extract-plugin
export default {"button":"ButtonIcon_button__osL0h","button-icon":"ButtonIcon_button-icon__to73u"};